type DebouncedFn<T extends unknown[]> = (...args: T) => void

export default function debounced<T extends unknown[]>(delay: number, fn: DebouncedFn<T>) {
	let timerId: ReturnType<typeof setTimeout> | null = null
	return function (...args: T) {
		if (timerId) {
			clearTimeout(timerId)
		}
		timerId = setTimeout(() => {
			fn(...args)
			timerId = null
		}, delay)
	}
}
